import {BACKEND_ENDPOINT} from '../../Constants'
import axiosInstance from '../../config/AxiosConfig'

const CLIENT_PATH = 'client'

export function getDetailClient(userId, id) {
    return axiosInstance
        .get(`${BACKEND_ENDPOINT}/${CLIENT_PATH}/getById`, {
            params: {userId, id},
        })
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}

export function createOrUpdateClient(userId, data) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/${CLIENT_PATH}/createOrUpdate`, data, {
            params: {
                userId,
            },
        })
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}

export function getPageClients(
    userId,
    pageNumber,
    pageRows,
    sortField,
    sortOrder,
    filterRequest,
) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/${CLIENT_PATH}/getPage`, filterRequest, {
            params: {
                userId,
                pageNumber,
                pageRows,
                sortField,
                sortOrder,
            },
        })
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}
